import React, { FC, useCallback, useState } from 'react';
import { Progress } from 'antd';

import FileIcon, { Size } from '../FileIcon';
import { IMAGE_SEARCHER_PATTERN } from './const';

import { UploadItemProps } from './types';

import { FileImage, NotFoundImage } from './styled';

export interface UploadFileIconProps extends Pick<UploadItemProps, 'file' | 'listType'> {
  onPreview?: () => void;
}

const UploadFileIcon: FC<UploadFileIconProps> = ({ file, listType, onPreview }) => {
  const size = listType === 'text' ? Size.Small : Size.Middle;
  const [error, setError] = useState(false);

  const onOverridePreview = useCallback(() => {
    if (file.status === 'error') return;

    onPreview && onPreview();
  }, [file.status, onPreview]);

  const onError = useCallback(() => setError(true), []);

  const onLoad = useCallback(() => setError(false), []);

  if (error) return <NotFoundImage size={size} />;

  if (file.status && file.status !== 'done' && file.status !== 'error' && listType === 'text') {
    return (
      <Progress type='circle' percent={file.percent} size='small' width={16} strokeWidth={16} />
    );
  }

  if (file.url && (file?.type || '').match(IMAGE_SEARCHER_PATTERN)?.length) {
    return (
      <FileImage
        src={file.url}
        size={size}
        onError={onError}
        onLoad={onLoad}
        onClick={onOverridePreview}
      />
    );
  }

  return (
    <FileIcon size={size} type={file.type} attention={file.error} onClick={onOverridePreview} />
  );
};

export default UploadFileIcon;
